import React, { Component } from "react";
import styled from "styled-components";
import { Row, Col, Alert, Button } from "react-bootstrap";
import LandingBanner from "./landing-banner";
import LandingCards from "./landing-cards";
import LandingCardsD from "./landing-cards-mobile";
import ContactForm from "./contact-form";
import Footer from "./footer.js";
// import Circuit from "./images/stockIMG.jpg";
import TextScroller from "./textScroller";
import Resources from "./resources";
import Testimonials from "./testimonials";

const middleBanner = (
  <p class="noItalics">
    
    Proudly&nbsp;Serving&nbsp;the&nbsp;Dialysis&nbsp;Community
    for&nbsp;Over&nbsp;25&nbsp;Years.
  </p>
);


const bottomBanner = (
  <p class="noItalics">
    We’ve got you covered with spare parts services for 2008K, 2008K2, 2008T, 2008T BlueStar, 
    and the SURDIAL™ DX Hemodialysis System!
  </p>
);

const StyledCookieAlert = styled(Alert)`
background-color: #00B5E2;
  position: fixed;
  bottom: 20px;
  width: 45%;
  left 27.5%;
  z-index: 700;
  @media(max-width: 500px){
    width: 100%;
    left: 0;
  }
`;
const StyledWebsiteUpdateAlert = styled(Alert)`

  position: fixed;
  bottom: 10px;
  width: 70%;
  left 15%;
  z-index: 600;
  @media(max-height: 900px){
    width: 80%;
    left: 10%;
      height:50%;
       overflow:auto;
  }
  @media(max-width: 1000px){
    width: 80%;
    left: 10%;
      height:650px;
       overflow:auto;
  }
`;
const AlertDismissible = (props) => {
  const alertOverride = localStorage.getItem("hideAlert");
 
  return (
    <>
      <StyledCookieAlert
        show={alertOverride ? !alertOverride : props.showAlert}
        variant="dark"
      >
        <Alert.Heading>Cookies Usage</Alert.Heading>
        <p>
          This site uses cookies to provide you with a great user experience. By
          using this website, you accept our{" "}
          <a href="/privacy-policy"> use of cookies</a>
        </p>
        <hr />
        <div className="d-flex justify-content-end">
          <Button onClick={() => props.hideAlert()} variant="outline-dark">
            I accept.
          </Button>
        </div>
      </StyledCookieAlert>
    </>
  );
};

class HSMLanding extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      width: window.innerWidth,
      showCovidModal: false,
      showAlert: true,
      showUpdateAlert: true,
    };
  }

  hideAlert = () => {
    this.setState({ showAlert: !this.state.showAlert });
    localStorage.setItem("hideAlert", true);
  };
  hideUpdateAlert = () => {
    this.setState({ showUpdateAlert: !this.state.showUpdateAlert });
    localStorage.setItem("hideUpdateAlert", true);
  };

  componentWillMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  renderLandingCards = () => {
    const width = this.state.width;
    const isMobile = width <= 800;
    return isMobile ? <LandingCards /> : <LandingCardsD />;
  };

  // <CarouselComp  />

  render() {
    return (
      <div>
        <div className="bodyContainer">
          <Row>
            <LandingBanner id="landingBannerFirst" text={middleBanner} />
          </Row>

          <Row id="LandingCardsRow">{this.renderLandingCards()}</Row>
          <Row>
            <TextScroller text={bottomBanner} />
          </Row>
          <Row id="testimonials">
            <Col xs={12} lg={12}>
              <Testimonials />
            </Col>
          </Row>

          <ContactForm />
          <Resources />
        </div>
        {
          <AlertDismissible
            showAlert={this.state.showAlert}
            hideAlert={this.hideAlert}
          />
          
        }
        <Footer />
      </div>
    );
  }

}
export default HSMLanding;
